<template>
  <div
    class="
      flex flex-col items-center gap-4 max-w-5xl
      p-10 lg:px-32 lg:py-16 text-center bg-EXPONDO-grey-5
    "
    data-testid="ctSearchError"
  >
    <div class="rounded-md p-3 bg-EXPONDO-grey">
      <span class="iconify svg--search-error text-EXPONDO-white text-5xl" />
    </div>
    <p>{{ $t('Something went wrong on our side. Please try again in a moment.') }}</p>
    <CustomButton
      type="primary"
      size="md"
      :full-width="false"
      :text="$t('Try again')"
      data-testid="ctSearchErrorRetry"
      @click="$emit('retry')"
    />
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'CtSearchError' });

defineEmits<{
  (event: 'retry'): void;
}>();
</script>
